<template>
  <div>
    <s-crud
      title="Configuración de Precios"
      add
      edit
      remove
      no-full
      :config="config"
      :filter="filter"
      @save="save($event)"
      @addEvent="addEvent($event)"
      @edit="editEvent($event)"
      @EditEvent="editEvent($event)"
      @rowSelected="rowSelectedS($event)"
      ref="crudprices"
      height="500"
      search
      searchInput
    >
      <template v-slot:options>
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              text
              black
              @click="openDialogGroupCertification()"
              small
            >
              <i class="fas fa-layer-group"></i>
            </v-btn>
          </template>
          <span>Grupo Certificaciones</span>
        </v-tooltip>

        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text black @click="openDialogGroupConfig()" small>
              <i class="fas fa-dollar-sign"></i>
              <i class="fas fa-igloo"></i>
            </v-btn>
          </template>
          <span>Grupo Congelado</span>
        </v-tooltip>
      </template>

      <template v-slot:filter>
        <v-container>
          <v-row justify="center">
            <v-col cols="12" lg="3">
              <s-select-definition
                v-model="filter.TypePrice"
                :def="1201"
                label="Tipo Precio:"
              ></s-select-definition>
            </v-col>
            <v-col cols="12" lg="3">
              <s-select-definition
                clearable
                full
                label="Zona"
                :def="1253"
                v-model="filter.ZneID"
              ></s-select-definition>
              <!--  <s-selected-zona
            v-model="filter.ZneID"
            full
            label="Zona"
          /> -->
            </v-col>
            <v-col cols="12" lg="3">
              <s-select-definition
                clearable
                v-model="filter.TypeDestiny"
                :def="1342"
                label="Destino:"
              ></s-select-definition>
            </v-col>

            <v-col cols="12" lg="3">
              <s-select-definition
                v-model="filter.TypeCultive"
                :def="1173"
                label="Cultivo"
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template scope="props">
        <v-container>
          <v-row>
            <v-col lg="3" class="s-col-form">
              <s-select-definition
                :def="1201"
                label="Tipo Precio"
                @input="getValue($event)"
                :text="props.item.TypePriceText"
                v-model="props.item.TypePrice"
              ></s-select-definition>
            </v-col>
            <v-col lg="3" class="s-col-form">
              <s-select-definition
                :def="1129"
                label="Tipo de moneda"
                v-model="props.item.TypeCurrency"
              ></s-select-definition>
            </v-col>
            <v-col lg="3" class="s-col-form" v-if="props.item.TypePrice != 3 && cValidated != 3">
              <s-select-definition
                clearable
                label="Zona"
                :def="1253"
                v-model="props.item.ZneID"
                ref="ZneRef"
              ></s-select-definition>
            </v-col>
            <v-col :lg="(props.item.TypePrice != 3 && cValidated != 3) ? 3 : 6" class="s-col-form">
              <s-select-definition
                label="Destino"
                :def="1342"
                v-model="props.item.TypeDestiny"
              ></s-select-definition>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="3" class="s-col-form">
              <s-select-definition
                v-model="props.item.TypeCrop"
                :def="1172"
                label="Tipo de cultivo"
              />
            </v-col>
            <v-col lg="3" class="s-col-form">
              <s-select-definition
                v-model="props.item.TypeCultive"
                :def="1173"
                label="Cultivo"
                ref="TypeCultive"
              />
            </v-col>
            <v-col lg="3" class="s-col-form">
              <s-select-variety
                :text="props.item.HvsCultiveText"
                :cultiveID="props.item.TypeCultive"
                label="Variedad"
                v-model="props.item.VrtID"
              />
            </v-col>
            <v-col :lg="typeDetail ? 2: 3" class="s-col-form">
              <s-text
                decimal
                label="Monto"
                ref="CfpAmount"
                v-model="props.item.CfpAmount"
              ></s-text>
            </v-col>
            <v-col cols="1" style="margin-top: 0px" v-if="typeDetail">
								<v-btn
									small
									color="info"
									elevation="1"
									fab
									
									@click="newItem(props.item.CfpAmount)"
								>
									<v-icon dark>
										mdi-plus
									</v-icon>
								</v-btn>
							</v-col>
          </v-row>

          <v-row>
            <v-col lg="3" class="s-col-form">
              <s-date
                label="Fecha Inicio"
                v-model="props.item.CfpDateBegin"
              ></s-date>
            </v-col>
            <v-col lg="3" class="s-col-form">
              <s-date
                label="Fecha Fin"
                v-model="props.item.CfpDateEnd"
              ></s-date>
            </v-col>
            <v-col lg="3" class="s-col-form">
              <s-select-payment v-if="!typeDetail"
                full                
                :typeCultive="props.item.TypeCultive"
                :TypeDestiny="props.item.TypeDestiny"
                label="Tipo Calibre"
                :text="props.item.CategoryCaliberText"
                v-model="props.item.CtgID"
              />
              <s-select-payment v-if="typeDetail"
                full
                :multiple="typeDetail"
                returnObject
                :typeCultive="props.item.TypeCultive"
                :TypeDestiny="props.item.TypeDestiny"
                label="Tipo Calibre Det"                
                v-model="Calibers"
              />
            </v-col>
            <v-col lg="3" class="s-col-form" v-if="props.item.TypePrice == 3 || cValidated == 3">
              <s-select-producer
                label="Productor"
                :text="props.item.PrdCardName"
                :value="props.item.PrdID || (PrdID && PrdID.PrdID ? PrdID.PrdID : PrdID)"
                return-object
                @input="inputProducer($event, props.item)"
              ></s-select-producer>
            </v-col>
            <v-col lg="3" class="s-col-form" v-if="props.item.TypePrice == 2 || cValidated == 2">
              <s-select-type-certification
                label="Tipo Certificado"
                full
                :text="props.item.TypeCertificationText"
                v-model="props.item.CrtID"
              >
              </s-select-type-certification>
            </v-col>
            <v-col
              lg="3"
              class="s-col-form"
              v-if="
                props.item.TypePrice == 1 ||
                props.item.TypePrice == 2 ||
                props.item.TypePrice == 3 ||
                props.item.TypePrice == 5 ||
                cValidated == 1 ||
                cValidated == 2 ||
                cValidated == 3 ||
                cValidated == 5
              "
            >
              <s-text
                decimal
                label="Monto Descarte"
                ref="CfpAmountDiscard"
                v-model="props.item.CfpAmountDiscard"
              ></s-text>
            </v-col>
            <v-col lg="3" class="s-col-form" v-show="props.item.TypePrice == 3 || cValidated == 3">
              <s-text
                disabled
                label="Código Productor"
                v-model="props.item.PrdCardCode"
              ></s-text>
            </v-col>
            <!-- <v-col lg="3" class="s-col-form">
              <v-btn color="primary" class="mt-2" block @click="openDialogGroupCertification()">
                Grupo Certificaciones
              </v-btn>
            </v-col> -->
            <span v-if="!props.item.CfpID > 0">
							<v-checkbox
								style="font-size: 20px;"
								label="Detalle"
								v-model="typeDetail"
								
							/>
						</span>
          </v-row>
          <v-row v-if="typeDetail">
            <v-col cols="12">
              <v-data-table
                            item-key="PldLine"
                            dense
                            :items-per-page="-1"
                            :items="itemsDetail"
                            :headers="headersDetail"
                            hide-default-footer
                          >
                <template v-slot:item.Actions="{ item }">
								<!-- <template v-slot:[`item.Actions`]="{ item }"> -->
									<v-btn
										@click="removeItem(item)"
										x-small
										color="error"
										elevation="0"
										block
									>
										<v-icon
											style="font-size: 16px !important"
											>fas fa-times</v-icon
										>
									</v-btn>
								</template>
              </v-data-table>
            </v-col>
          </v-row>
          
        </v-container>
      </template>
      <template v-slot:ExistSap="{ row }">
        <v-chip x-small dark :color="row.ExisteSAP == 1 ? 'success' : 'error'">
          {{ row.ExisteSAP == 1 ? "SI" : "NO" }}
        </v-chip>
      </template>
      <template v-slot:CfpStatusName="{ row }">
        <v-chip
          x-small
          dark
          :color="
            row.CfpStatus == 1 ? 'success' : row.CfpStatus == 2 ? 'error' : ''
          "
        >
          {{ row.CfpStatusName }}
        </v-chip>
      </template>
      <template v-slot:accion="{ row }">
        <div>
          <v-btn
            v-if="row.CfpStatus != 1"
            x-small
            dark
            color="warning"
            @click="duplicate(row)"
          >
            Duplicar
          </v-btn>
        </div>
      </template>
    </s-crud>

    <v-dialog v-model="dialogFrozenGroup"> </v-dialog>

    <v-dialog v-model="dialogDuplicate" persistent width="700">
      <v-card>
        <v-container>
          <v-row>
            <v-col cols="4">
              <s-text
                decimal
                label="Monto"
                ref="CfpAmount"
                v-model="itemDuplicate.CfpAmount"
              ></s-text>
            </v-col>
            <v-col cols="4">
              <s-date
                label="Fecha Inicio"
                v-model="itemDuplicate.CfpDateBegin"
              ></s-date>
            </v-col>
            <v-col cols="4">
              <s-date
                label="Fecha Fin"
                v-model="itemDuplicate.CfpDateEnd"
              ></s-date>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn color="warning" block @click="closeDialogDuplicate()">
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn color="primary" block @click="duplicateSave()">
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGroupCertification" persistent width="1000">
      <v-card>
        <v-container>
          <v-row>
            <s-toolbar
              label="Grupos de Certificaciones"
              dark
              color="#8E8F91"
              close
              @close="closeDialogGroupCertification()"
              :save="!isEdit"
              @save="groupCertificationSave()"
              :add="isEdit"
              @add="addGroup()"
            ></s-toolbar>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-row class="mt-3">
                <v-col class="pb-0 pt-0">
                  <h2>Datos Generales</h2>
                </v-col>
              </v-row>
              <v-col class="pl-0 pr-0"><v-divider></v-divider> </v-col>
              <v-row>
                <v-col cols="6">
                  <s-date
                    label="Fecha Inicio"
                    v-model="itemGroupCertification.CpgDateBegin"
                    :readonly="isEdit"
                  ></s-date>
                </v-col>
                <v-col cols="6">
                  <s-date
                    label="Fecha Fin"
                    v-model="itemGroupCertification.CpgDateEnd"
                    :readonly="isEdit"
                  ></s-date>
                </v-col>
                <v-col cols="6" class="s-col-form">
                  <s-select-definition
                    :def="1129"
                    label="Tipo de moneda"
                    v-model="itemGroupCertification.TypeCurrency"
                  ></s-select-definition>
                </v-col>
                <v-col cols="6" class="s-col-form">
                  <s-text
                    label="Monto"
                    decimal
                    v-model="itemGroupCertification.CpgAmount"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
                <v-col cols="6" class="s-col-form">
                  <s-text
                    label="Monto Descarte"
                    decimal
                    v-model="itemGroupCertification.CpgAmountDiscard"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
                <!-- <v-col cols="6" class="s-col-form">
                  <s-select-definition
                    label="Estado"
                    :def="1351"
                    v-model="itemGroupCertification.CpgStatus"
                  ></s-select-definition>
                </v-col> -->
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row class="mt-3">
                <v-col class="pb-0 pt-0">
                  <h2>Certificaciones</h2>
                </v-col>
                <v-spacer></v-spacer>
                <v-btn
                  class="mr-3 elevation-5"
                  x-small
                  fab
                  color="warning"
                  @click="addItemCertification()"
                >
                  <i class="fas fa-plus"></i>
                </v-btn>
              </v-row>
              <v-col class="pl-0 pr-0"><v-divider></v-divider> </v-col>
              <v-row justify="center">
                <v-col>
                  <s-select-type-certification
                    label="Tipo Certificado"
                    full
                    return-object
                    v-model="objCertification"
                  >
                  </s-select-type-certification>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :items="itemCertifications"
                    :headers="headersCertifications"
                    :items-per-page="-1"
                    hide-default-footer
                    dense
                  >
                    <!-- <template v-slot:item.accion="{ item }"> -->
                    <template v-slot:[`item.accion`]="{ item }">
                      <v-btn
                        v-if="!isEdit"
                        block
                        color="error"
                        @click="removeItemCertification(item)"
                        x-small
                      >
                        <v-icon>mdi-close</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-col class="pl-0 pr-0"><v-divider></v-divider> </v-col>
          <v-row>
            <v-col>
              <v-data-table
                v-model="selected"
                :items="itemsCertificationGroup"
                :headers="headerGroupCertifications"
                @click:row="rowSelected($event)"
                item-key="CpgID"
                dense
              >
                <template v-slot:[`item.accion`]="{ item }">
                  <v-btn
                    block
                    color="error"
                    @click="deleteGroupCertification(item)"
                    x-small
                  >
                    <v-icon>mdi-close</v-icon></v-btn
                  >
                </template>
                <template v-slot:[`item.CpgStatusName`]="{ item }">
                  <!-- <template v-slot:item.CpgStatusName="{ item }"> -->
                  <v-chip x-small :color="item.CpgStatusColor">
                    {{ item.CpgStatusName }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGroupConfig" persistent width="1000">
      <v-card>
        <v-container v-if="dialogGroupConfig">
          <v-row>
            <s-toolbar
              label="Configuracion Grupal"
              dark
              color="#8E8F91"
              close
              @close="closeDialogGroupConfig()"
              :save="!isEdit"
              @save="groupConfigSave()"
              :add="isEdit"
              @add="addGroup()"
            ></s-toolbar>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-row>
                <v-col lg="3" class="s-col-form">
                  <s-select-definition
                    :def="1129"
                    label="Tipo de moneda"
                    v-model="TypeCurrencyGc"
                  ></s-select-definition>
                </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-select-definition
                    v-model="TypePriceGc"
                    :def="1201"
                    label="Tipo Precio:"
                  ></s-select-definition>
                </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-text label="Precio" decimal v-model="AmountGc" />
                </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-text
                    label="Precio Descarte"
                    decimal
                    v-model="AmountDiscardGc"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="3" class="s-col-form">
                  <s-select-definition
                    v-model="TypeCultiveGc"
                    :def="1173"
                    label="Cultivo"
                  />
                </v-col>
                <!-- <v-col cols="3"  lg="3" class="s-col-form">
              <s-select-payment
                full
                :typeCultive="TypeCultiveGc"
                label="Tipo Calibre"
                :text="CategoryCaliberText"
                v-model="CtgID"
              ></s-select-payment>
            </v-col> -->

                <v-col cols="3" class="s-col-form">
                  <s-text
                    label="Monto Bolilla"
                    decimal
                    v-model="CfpAmountBolillo"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-text
                    label="Monto Devol. Por Pagar"
                    decimal
                    v-model="CfpAmountDevolution"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-text
                    label="Monto Bolilla Maquila"
                    decimal
                    v-model="CfpAmountBolilloMaq"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-text
                    label="Monto Descarte Maquila"
                    decimal
                    v-model="CfpAmountDiscardMaq"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
                <v-col cols="4" class="s-col-form">
                  <s-text
                    label="Monto Descarte No Aceptada Maq."
                    decimal
                    v-model="CfpAmountDiscardNotAcepptedMaq"
                    :readonly="isEdit"
                  ></s-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7">
                  <s-select-producer
                    label="Productor"
                    v-model="PrdIDConfig"
                    return-object
                    @input="changeSelectProducer($event)"
                  ></s-select-producer>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    rounded
                    fab
                    x-small
                    @click="btnAddProdGroupConfig()"
                    class="mt-3"
                    ><i class="fas fa-plus"></i
                  ></v-btn>
                </v-col>
                <!--:text="props.item.PrdCardName"-->
              </v-row>
              <v-col class="pl-0 pr-0"><v-divider></v-divider> </v-col>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :items="itemsProdGroupConfig"
                    :headers="headersProdGroupConfig"
                    :items-per-page="-1"
                    hide-default-footer
                    dense
                  >
                    <!-- <template v-slot:item.accion="{ item }"> -->
                    <template v-slot:[`item.accion`]="{ item }">
                      <v-btn
                        block
                        color="error"
                        @click="removeItemProdGroupConfig(item)"
                        x-small
                      >
                        <v-icon>mdi-close</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="4">
              <v-row>
                <v-col>
                  <s-select
                    v-model="NumberWeeksYear"
                    :items="NumberWeeksYearRange"
                    label="Semana"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    v-model="days"
                    label="Lunes"
                    color="red"
                    value="1"
                    hide-details
                  ></v-checkbox>

                  <v-checkbox
                    v-model="days"
                    label="Martes"
                    color="primary"
                    value="2"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="days"
                    label="Miercoles"
                    color="orange"
                    value="3"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="days"
                    label="Jueves"
                    color="succes"
                    value="4"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="days"
                    label="Viernes"
                    color="info"
                    value="5"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="days"
                    label="Sabado"
                    color="indigo"
                    value="6"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="days"
                    label="Domingo"
                    color="red"
                    value="7"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import sSelectedZona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedZona";
import SSelectDefinition from "../../../components/Utils/SSelectDefinition.vue";
import SText from "../../../components/Utils/SText.vue";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import sProducerService from "@/services/Technicalassistance/ConfigurationPrice";
import sSelectPayment from "@/components/CategoryPayment/SSelectPayment.vue";
import SSelectTypeCertification from "../../../components/Utils/Certification/sSelectTypeCertification.vue";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
import _sConfigurationPriceGroupService from "@/services/Technicalassistance/ConfigurationPriceGroupService.js";
/**["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"] */
export default {
  components: {
    SText,
    sSelectedZona,
    SSelectDefinition,
    SSelectProducer,
    sProducerService,
    sSelectPayment,
    SSelectTypeCertification,
    SSelectVariety,
  },
  data: () => ({
    PrdCardCode: "",
    NumberWeeksYearRange: [],
    NumberWeeksYear: 0,
    AmountDiscardGc: 0,
    CfpAmountBolillo: 0,
    CfpAmountDevolution: 0,
    CfpAmountBolilloMaq: 0,
    CfpAmountDiscardMaq: 0,
    CfpAmountDiscardNotAcepptedMaq: 0,
    TypeCultiveGc: 0,
    CtgID: 0,
    TypePriceGc: 0,
    TypeCurrencyGc: 0,
    CategoryCaliberText: "",
    AmountGc: 0,
    days: [],
    isEdit: false,
    selected: [],
    itemsProdPriceConfigRange: [],
    itemsProdGroupConfig: [],
    itemsCertificationGroup: [],
    headersProdPriceConfigRange: [
      { text: "ID", value: "CfpID" },
      { text: "Tipo de Precio", value: "TypePrice" },

      { text: "Precio", value: "CfpAmount" },
      { text: "Precio de descarte", value: "CfpAmountDiscard" },
      { text: "Productor", value: "PrdCardName" },
      { text: "Fecha Inicio", value: "CfpDateBegin" },
      { text: "Fecha Fin", value: "CfpDateEnd" },
      { text: "Tipo de Moneda", value: "TypeCurrency" },
    ],
    headersProdGroupConfig: [
      { text: "ID", value: "PrdID" },
      { text: "Productor", value: "PrdCardName" },
      { text: "Codigo", value: "PrdCardCode" },
      { text: "Acciones", value: "accion" },
    ],
    headerGroupCertifications: [
      { text: "ID", value: "CpgID" }, //CpgAmountDiscard//TypeCurrency
      { text: "Fecha Inicio", value: "CpgDateBegin" },
      { text: "Fecha Fin", value: "CpgDateEnd" },
      { text: "Monto", value: "CpgAmount" },
      { text: "Monto Descarte", value: "CpgAmountDiscard" },
      { text: "Certificaciones", value: "CertificationsName" },
      { text: "Estado", value: "CpgStatusName" },
      { text: "Acción", value: "accion" },
    ],
    objCertification: {},
    headersCertifications: [
      { text: "Certificación", value: "CrtName" },
      { text: "Acción", value: "accion" },
    ],
    headersDetail: [
        { text: "ID", value: "CtgID", width: 40 },
				{ text: "Categoria", value: "CategoryCaliberText", width: 40 },
				{ text: "Monto", value: "CfpAmount", width: 60 },
				// { text: "Monto Descarte", value: "CfpAmountDiscard", width: 120 },
				{ text: "Grupo", value: "GroupName", width: 150 },			
        { text: "Acciones", value: "Actions", width: 60 },
			],
    itemCertifications: [],
    itemGroupCertification: {},
    itemsDetail:[],
    Calibers: [],
    dialogGroupCertification: false,
    dialogGroupConfig: false,
    dialogDuplicate: false,
    itemDuplicate: {},
    filter: {
      CfpTypePrice: 0,
      TypePrice: 0,
    },
    cValidated: 0,
    ObjPrecio: {
      CalibreObj: null,
    },
    PrdID: null,
    PrdIDConfig: {},
    //ObjCalibre: {},
    //ObjLocalidad: {},
    ObjCertificacion: {
      CertificacionObj: null,
    },
    config: {
      title: "Config",
      model: {
        CfpID: "ID",
        CfpAmount: "decimal4",
        CfpAmountDiscard: "decimal4",
        CfpAmountBolillo: "decimal4",
        CfpAmountDevolution: "decimal4",
        CfpAmountBolilloMaq: "decimal4",
        CfpAmountDiscardMaq: "decimal4",
        CfpAmountDiscardNotAcepptedMaq: "decimal4",
        DedDescription: "",
        CfpDateBegin: "date",
        CfpDateEnd: "date",
        CfpStatusName: "",
        accion: "",
      },
      service: sProducerService,
      headers: [
        { text: "Acción", value: "accion" },
        {
          text: "Existe en SAP",
          value: "ExistSap",
          width: 80,
          align: "center",
        },
        { text: "ID", value: "CfpID" },
        { text: "Destino", value: "TypeDestinyName" },
        { text: "RcfID", value: "RcfID", width: 60 },
        { text: "Tipo Precio", value: "TypePriceText", width: 150 },
        { text: "Moneda", value: "TypeCurrencyName", width: 150 },
        { text: "Tipo Cultivo", value: "TypeCropName" },
        { text: "Zona", value: "ZneName" },
        { text: "Variedad", value: "VrtName" },
        { text: "Categoria", value: "CategoryCaliberText" },
        { text: "Cultivo", value: "TypeCultiveName" },
        { text: "Importe", value: "CfpAmount" },
        { text: "Monto Descarte", value: "CfpAmountDiscard" },
        { text: "Monto Bolilla", value: "CfpAmountBolillo" },
        { text: "Monto Devolucion", value: "CfpAmountDevolution" },
        { text: "Monto Bolilla Maquila", value: "CfpAmountBolilloMaq" },
        { text: "Monto Descarte Maquila", value: "CfpAmountDiscardMaq" },
        { text: "Monto Descarte No Aceptable Maquila", value: "CfpAmountDiscardNotAcepptedMaq" },
        { text: "Fecha Inicio", value: "CfpDateBegin" },
        { text: "Fecha Fin", value: "CfpDateEnd" },
        { text: "Estado", value: "CfpStatusName" },
        { text: "Zona Ubi.", value: "ZneName" },
        // { text: "Existe Sap", value: "ExisteSAP" },
      ],
    },
    dialogFrozenGroup: false,
    typeDetail:false,
  }),

  watch: {
    filter(newValue, oldValue) {
      // console.log('filter ', this.filter);
    },
    'typeDetail'(){
      console.log("TypeCultiov", this.$refs.TypeCultive.value)
      //this.$refs.TypeCultive.value =  2;
    }
  },

  methods: {
    removeItem(item){
      let position = this.itemsDetail.indexOf(item);
      let elementoEliminado = this.itemsDetail.splice(position, 1);
    },
    newItem(val) {
        console.log("Montooo", this.$refs.CfpAmount.value);
        console.log("Calibres seleccionado",this.Calibers);
        let amount = this.$refs.CfpAmount.value;
        // let amountDiscard = this.$refs.CfpAmountDiscard.value;

        this.Calibers.forEach(element => {
          let item = {
            CtgID : element.CtgID,
            CategoryCaliberText : element.CtgDescription,
            CfpAmount : amount,
            //CfpAmountDiscard: amountDiscard,
            GroupName: element.TypeGroupName
          }


          let exist  = this.itemsDetail.find((cal) => cal.CtgID === element.CtgID )
          if (exist){
            console.log("Ya esta")
          }else{
            this.itemsDetail.push(item);
          }

        }) 
    },
    clear(){
      this.itemsDetail = [];
      this.typeDetail = false;
    },
    changeTypePrice(item) {
      this.PrdCardCode = "";
    },
    addEvent(item) {
      this.PrdCardCode = "";
      this.cValidated = 0;
      this.PrdID = null;
      if (item) {
        this.$set(item, "PrdID", 0);
        this.$set(item, "PrdCardCode", "");
        this.$set(item, "PrdCardName", "");
      }
    },
    inputProducer(producer, item) {
      if (producer === null || producer === undefined || producer === "") {
        this.PrdCardCode = "";
        this.PrdID = null;
        if (item) {
          this.$set(item, "PrdID", 0);
          this.$set(item, "PrdCardCode", "");
          this.$set(item, "PrdCardName", "");
        }
        return;
      }

      if (typeof producer === "object") {
        const id = producer.PrdID || (item ? item.PrdID : 0);
        const code = producer.PrdCardCode || (item ? item.PrdCardCode : "") || this.PrdCardCode || "";
        const name = producer.PrdCardName || (item ? item.PrdCardName : "") || "";

        this.PrdCardCode = code;
        this.PrdID = producer;

        if (item) {
          this.$set(item, "PrdID", id);
          this.$set(item, "PrdCardCode", code);
          this.$set(item, "PrdCardName", name);
        }
      } else if (typeof producer === "number" || typeof producer === "string") {
        const id = Number(producer);
        if (item) {
          this.$set(item, "PrdID", id);
          if (item.PrdCardCode) {
            this.PrdCardCode = item.PrdCardCode;
          } else if (this.PrdCardCode) {
            this.$set(item, "PrdCardCode", this.PrdCardCode);
          }
        }
      }
    },
    btnAddProdGroupConfig() {
      // console.log("this.PrdIDConfig", this.PrdIDConfig);
      let p = this.PrdIDConfig;
      if (p == null) {
        return;
      }
      if (p.PrdID > 0) {
        var elem = this.itemsProdGroupConfig.find(
          (element) => element.PrdID == p.PrdID,
        );
        // console.log(elem);
        if (elem == null) {
          this.itemsProdGroupConfig.push({
            PrdID: p.PrdID,
            PrdCardCode: p.PrdCardCode,
            PrdCardName: p.PrdCardName,
          });
        }
      }
      this.PrdIDConfig = {};
    },
    removeItemProdGroupConfig(item) {
      let position = this.itemsProdGroupConfig.indexOf(item);
      let elementoEliminado = this.itemsProdGroupConfig.splice(position, 1);

      //console.log("item samir", elementoEliminado);
    },
    groupConfigSave() {
      if (this.itemsProdGroupConfig.length == 0) {
        this.$fun.alert("No se ha agregado ningun Productor", "warning");
        return;
      }
      if (this.days.length == 0) {
        this.$fun.alert("No se ha Seleccionado Dias", "warning");
        return;
      }
      if (this.AmountGc <= 0) {
        this.$fun.alert("El Precio no debe ser 0", "warning");
        return;
      }
      if (this.TypeCultiveGC <= 0) {
        this.$fun.alert("Debe seleccionar un Tipo Cultivo", "warning");
        return;
      }
      //this.TypeCultiveGC
      /*if (this.AmountDiscardGc <= 0) {
          this.$fun.alert("El Precio de descarte no debe ser 0", "warning");
        return;
      }*/

      let dataGroupConfig = {
        itemsProdGroupConfig: this.itemsProdGroupConfig,
        days: this.days,
        Amount: this.AmountGc,
        AmountDiscard: this.AmountDiscardGc,
        TypePrice: this.TypePriceGc,
        TypeCurrency: this.TypeCurrencyGc,
        TypeCultive: this.TypeCultiveGc,
        NumberWeeksYear: this.NumberWeeksYear,
        CfpAmountBolillo: this.CfpAmountBolillo,
        CfpAmountDevolution: this.CfpAmountDevolution,
        CfpAmountBolilloMaq: this.CfpAmountBolilloMaq,
        CfpAmountDiscardMaq: this.CfpAmountDiscardMaq,
        CfpAmountDiscardNotAcepptedMaq : this.CfpAmountDiscardNotAcepptedMaq
        //CtgId : this.CtgID
      };
      console.log("samir dataGroupConfig", dataGroupConfig);

      //samir

      this.$fun.alert("¿Desea Guardar?", "question").then((r) => {
        if (r.value) {
          _sConfigurationPriceGroupService
            .groupconfigsave(dataGroupConfig, this.$fun.getUserID())
            .then((r) => {
              // console.log("samir config", r.data);
              this.dialogGroupConfig = false;
              this.$fun.alert("Datos Guardados correctamente", "success");
            });
        }
      });
    },
    changeSelectProducer(p) {
      // console.log("productor", p);
    },
    addGroup() {
      this.itemCertifications = [];
      this.itemGroupCertification = {};
      this.isEdit = false;
    },

    validateNewGroupCertification() {
      let has = false;
      let certificationsNew = [];
      this.itemCertifications.forEach((element) => {
        certificationsNew.push(element.CrtName);
      });
      let certificationsNewJoin = certificationsNew.join(", ");
      this.itemsCertificationGroup.forEach((item) => {
        if (
          item.CertificationsName == certificationsNewJoin &&
          item.CpgStatus == 1
        ) {
          has = true;
        }
      });
      return has;
    },

    closeDialogGroupCertification() {
      this.dialogGroupCertification = false;
      this.itemCertifications = [];
      this.itemGroupCertification = {};
    },
    closeDialogGroupConfig() {
      this.dialogGroupConfig = false;
      this.itemCertifications = [];
      this.itemGroupCertification = {};
    },

    rowSelected(row) {
      this.itemGroupCertification = row;
      let arr = [row];
      this.selected = arr;
      _sConfigurationPriceGroupService
        .detaillist(row.CpgID, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status == 200) {
            this.itemCertifications = resp.data;
            if (this.itemCertifications.length > 0) {
              this.isEdit = true;
            } else {
              this.isEdit = false;
            }
            this.selected = [];
          }
        });
    },
    rowSelectedS(row) {
      console.log("Fila", row);
      if (row && row.length > 0) {
        this.loadRowData(row[0]);
      }
    },
    editEvent(item) {
      if (Array.isArray(item)) {
        item = item[0];
      }
      if (item) {
        this.loadRowData(item);
      }
    },
    loadRowData(item) {
      if (Array.isArray(item)) {
        item = item[0];
      }
      if (!item) return;

      this.cValidated = item.TypePrice;
      if (item.TypePrice == 3) {
        const code = item.PrdCardCode || "";
        const name = item.PrdCardName || "";
        const id = item.PrdID ? Number(item.PrdID) : 0;

        this.PrdCardCode = code;
        this.PrdID = id
          ? {
              PrdID: id,
              PrdCardName: name,
              PrdCardCode: code,
            }
          : null;

        this.$set(item, "PrdID", id);
        this.$set(item, "PrdCardCode", code);
        this.$set(item, "PrdCardName", name);
      } else {
        this.PrdID = null;
        this.PrdCardCode = "";
      }
    },

    deleteGroupCertification(item) {
      this.$fun.alert("¿Seguro de eliminar?", "question").then((r) => {
        if (r.value) {
          item.SecStatus = 0;
          item.UsrUpdateID = this.$fun.getUserID();
          _sConfigurationPriceGroupService
            .save(item, this.$fun.getUserID())
            .then((resp) => {
              if (resp.status == 200) {
                this.$fun.alert("Guardado Correctamente", "success");
                _sConfigurationPriceGroupService
                  .list(this.$fun.getUserID())
                  .then((resp) => {
                    if (resp.status == 200) {
                      resp.data.forEach((element) => {
                        element.CpgDateBegin = this.$moment(
                          element.CpgDateBegin,
                        ).format(this.$const.FormatDateDB);
                        element.CpgDateEnd = this.$moment(
                          element.CpgDateEnd,
                        ).format(this.$const.FormatDateDB);
                      });
                      this.itemsCertificationGroup = resp.data;
                      this.itemCertifications = [];
                      this.itemGroupCertification = {};
                    }
                  });
              }
            });
        }
      });
    },

    openDialogGroupCertification() {
      this.dialogGroupCertification = true;
      _sConfigurationPriceGroupService
        .list(this.$fun.getUserID())
        .then((resp) => {
          if (resp.status == 200) {
            // console.log('abrio ', resp.data);
            resp.data.forEach((element) => {
              element.CpgDateBegin = this.$moment(element.CpgDateBegin).format(
                this.$const.FormatDateDB,
              );
              element.CpgDateEnd = this.$moment(element.CpgDateEnd).format(
                this.$const.FormatDateDB,
              );
            });
            this.itemsCertificationGroup = resp.data;
          }
        });
    },
    openDialogGroupConfig() {
      this.dialogGroupConfig = true;
      //samir
    },
    removeItemCertification(item) {
      this.itemCertifications = this.itemCertifications.filter((element) => {
        return element.CrtID != item.CrtID;
      });
    },

    addItemCertification() {
      if (this.objCertification.TcID == undefined) {
        this.$fun.alert("Ingrese certificación", "warning");
        return;
      }
      let detail = {
        CpgID: 0,
        CpgID: 0,
        CrtID: this.objCertification.TcID,
        CrtName: this.objCertification.TcDescription,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
        UsrUpdateID: this.$fun.getUserID(),
      };
      this.itemCertifications.push(detail);
    },

    groupCertificationSave() {
      if (
        this.itemGroupCertification.CpgAmount == 0 ||
        this.itemGroupCertification.CpgAmount == "" ||
        this.itemGroupCertification.CpgAmount == undefined
      ) {
        this.$fun.alert("Ingrese monto", "warning");
        return;
      }
      if (this.itemCertifications.length < 2) {
        this.$fun.alert(
          "Tiene que ingresar al menos dos certificaciones",
          "warning",
        );
        return;
      }
      this.$fun.alert("¿Seguro de guardar?", "question").then((r) => {
        if (r.value) {
          this.itemGroupCertification.CpgID = this.isEdit
            ? this.itemGroupCertification.CpgID
            : 0;
          this.itemGroupCertification.CpgStatus = 1;
          this.itemGroupCertification.SecStatus = 1;
          this.itemGroupCertification.UsrCreateID = this.$fun.getUserID();
          this.itemGroupCertification.UsrUpdateID = this.$fun.getUserID();
          this.itemGroupCertification.TasConfigurationPriceGroupDetails =
            this.itemCertifications;
          if (this.validateNewGroupCertification()) {
            this.$fun.alert(
              "Ya existe un grupo de certificaciones registrado",
              "warning",
            );
          } else {
            _sConfigurationPriceGroupService
              .save(this.itemGroupCertification, this.$fun.getUserID())
              .then((resp) => {
                if (resp.status == 200) {
                  this.$fun.alert("Guardado Correctamente", "success");
                  this.dialogGroupCertification = false;
                  this.itemCertifications = [];
                }
              });
          }
        }
      });
    },

    closeDialogDuplicate() {
      this.dialogDuplicate = false;
    },

    duplicate(row) {
      row.CfpID = 0;
      this.itemDuplicate = row;
      this.dialogDuplicate = true;
    },

    duplicateSave() {
      if (
        this.itemDuplicate.CfpAmount == null ||
        this.itemDuplicate.CfpAmount === "" ||
        this.itemDuplicate.CfpAmount === 0
      ) {
        this.$refs.CfpAmount.error("Ingrese Monto");
        return;
      }
      if (Number(this.itemDuplicate.CfpAmount) <= 0) {
        this.$refs.CfpAmount.error("El monto debe ser mayor a Cero");
        return;
      }
      this.$fun.alert("Seguro de guardar?", "question").then((r) => {
        if (r.value) {
          if (this.itemDuplicate.CfpAmount == null || String(this.itemDuplicate.CfpAmount).trim() === "") this.itemDuplicate.CfpAmount = 0;
          if (this.itemDuplicate.CfpAmountDiscard == null || String(this.itemDuplicate.CfpAmountDiscard).trim() === "") this.itemDuplicate.CfpAmountDiscard = 0;
          if (this.itemDuplicate.CfpAmountBolillo == null || String(this.itemDuplicate.CfpAmountBolillo).trim() === "") this.itemDuplicate.CfpAmountBolillo = 0;
          if (this.itemDuplicate.CfpAmountDevolution == null || String(this.itemDuplicate.CfpAmountDevolution).trim() === "") this.itemDuplicate.CfpAmountDevolution = 0;
          if (this.itemDuplicate.CfpAmountBolilloMaq == null || String(this.itemDuplicate.CfpAmountBolilloMaq).trim() === "") this.itemDuplicate.CfpAmountBolilloMaq = 0;
          if (this.itemDuplicate.CfpAmountDiscardMaq == null || String(this.itemDuplicate.CfpAmountDiscardMaq).trim() === "") this.itemDuplicate.CfpAmountDiscardMaq = 0;
          if (this.itemDuplicate.CfpAmountDiscardNotAcepptedMaq == null || String(this.itemDuplicate.CfpAmountDiscardNotAcepptedMaq).trim() === "") this.itemDuplicate.CfpAmountDiscardNotAcepptedMaq = 0;
          this.itemDuplicate.PrdID = Number(this.itemDuplicate.PrdID || 0);
          this.itemDuplicate.ZneID = Number(this.itemDuplicate.ZneID || 0);
          this.itemDuplicate.VrtID = Number(this.itemDuplicate.VrtID || 0);
          this.itemDuplicate.SecStatus = 1;
          delete this.itemDuplicate.DateBegin;
          delete this.itemDuplicate.DateEnd;
          delete this.itemDuplicate.SecCreate;
          delete this.itemDuplicate.SecUpdate;

          sProducerService
            .save(this.itemDuplicate, this.$fun.getUserID())
            .then((resp) => {
              if (resp.status == 200) {
                this.$fun.alert("Ingresado Correctamente", "success");
                this.closeDialogDuplicate();
                this.$refs.crudprices.refresh();
              }
            });
        }
      });
    },

    Initialize() {
      this.filter = {};
    },
    save(item) {
      console.log("item", item);

      if (item.TypePrice == 1) {
        item.PrdID = 0;
        item.CrtID = null;
      } else if (item.TypePrice == 2) {
        item.PrdID = 0;
      } else if (item.TypePrice == 3) {
        const prodId = item.PrdID ? Number(item.PrdID) : (this.PrdID && this.PrdID.PrdID ? Number(this.PrdID.PrdID) : (this.PrdID ? Number(this.PrdID) : 0));
        item.PrdID = prodId;
        item.CrtID = null;
      }
      // Mantener CtgID si existe
      item.CtgID = item.CtgID ? Number(item.CtgID) : null;

      if (this.cValidated != 3) {
        if (item.ZneID == null) {
          //this.$refs.ZneID.error('Ingrese Zona');
          this.$fun.alert("Ingrese Zona", "warning");
          return;
        }
      }

      if (this.typeDetail) {
        console.log("Guarda Masivo");

        let itemsMassive = [];
        this.itemsDetail.forEach(element => {        
          let itemDetail = {
            CfpID: 0,
            CfpAmount: Number(element.CfpAmount || 0),
            CfpAmountDiscard: Number(item.CfpAmountDiscard || 0),
            TypePrice: Number(item.TypePrice || 0),
            CfpDateBegin: item.CfpDateBegin,
            CfpDateEnd: item.CfpDateEnd,
            SecStatus: 1,
            PrdID: Number(item.PrdID || 0),
            CtgID: element.CtgID,
            ZneID: Number(item.ZneID || 0),
            TypeCrop: Number(item.TypeCrop || 0),
            TypeCultive: Number(item.TypeCultive || 0),
            VrtID: Number(item.VrtID || 0),
            TypeDestiny: Number(item.TypeDestiny || 0),
            TypeCurrency: Number(item.TypeCurrency || 0),
            CfpStatus: Number(item.CfpStatus || 1),
            CrtID: item.CrtID,
            UsrCreateID: this.$fun.getUserID(),            
          };
          itemsMassive.push(itemDetail);
        });

        sProducerService.saveMassive(itemsMassive, this.$fun.getUserID()).then(resp => {
          if (resp.status == 200) {
            this.$fun.alert("Se registro correctamente", "success"); 
            this.clear();
            this.$refs.crudprices.refresh();
          } else {
            this.$fun.alert("No se registro correctamente", "warning"); 
            console.log("Resp", resp);
          }
        });
        return;
      }

      if (item.ExisteSAP == 1) {
        this.$fun.alert(
          "No se puede editar el precio porque el Lote ya existe en SAP",
          "warning",
        );
        return;
      }
      if (item.CfpAmount == null) {
        this.$refs.CfpAmount.error("Ingrese Monto");
        return;
      }
      if (String(item.CfpAmount).trim() == "") {
        this.$refs.CfpAmount.error("Ingrese Monto");
        return;
      }
      if (Number(item.CfpAmount) <= 0) {
        this.$refs.CfpAmount.error("El monto debe ser mayor a Cero");
        return;
      }
      
      // Saneamiento de montos decimales (conservando ceros decimales en pantalla, ej: 2.600)
      if (item.CfpAmount == null || String(item.CfpAmount).trim() === "") item.CfpAmount = 0;
      if (item.CfpAmountDiscard == null || String(item.CfpAmountDiscard).trim() === "") item.CfpAmountDiscard = 0;
      if (item.CfpAmountBolillo == null || String(item.CfpAmountBolillo).trim() === "") item.CfpAmountBolillo = 0;
      if (item.CfpAmountDevolution == null || String(item.CfpAmountDevolution).trim() === "") item.CfpAmountDevolution = 0;
      if (item.CfpAmountBolilloMaq == null || String(item.CfpAmountBolilloMaq).trim() === "") item.CfpAmountBolilloMaq = 0;
      if (item.CfpAmountDiscardMaq == null || String(item.CfpAmountDiscardMaq).trim() === "") item.CfpAmountDiscardMaq = 0;
      if (item.CfpAmountDiscardNotAcepptedMaq == null || String(item.CfpAmountDiscardNotAcepptedMaq).trim() === "") item.CfpAmountDiscardNotAcepptedMaq = 0;

      // Saneamiento de IDs y tipos numéricos
      item.CfpID = Number(item.CfpID || 0);
      item.PrdID = Number(item.PrdID || 0);
      item.ZneID = Number(item.ZneID || 0);
      item.VrtID = Number(item.VrtID || 0);
      item.TypeCrop = Number(item.TypeCrop || 0);
      item.TypeCultive = Number(item.TypeCultive || 0);
      item.TypeDestiny = Number(item.TypeDestiny || 0);
      item.TypeCurrency = Number(item.TypeCurrency || 0);
      item.TypePrice = Number(item.TypePrice || 0);
      item.CfpStatus = Number(item.CfpStatus || 1);
      item.SecStatus = 1;

      // Limpiar propiedades de vista y auditoría que ensucian el payload
      delete item.DateBegin;
      delete item.DateEnd;
      delete item.SecCreate;
      delete item.SecUpdate;

      console.log("item guardar", item);
      //item.LocationID = this.ObjLocalidad;
      item.save();
    },
    getValue(val) {
      if (this.cValidated !== val) {
        this.cValidated = val;
        this.PrdID = null;
        this.PrdCardCode = "";
      }
    },
  },
  created() {
    this.filter = {};

    let anioCurrent = new Date().getFullYear();
    // console.log("anioCurrent", anioCurrent);

    this.NumberWeeksYearRange = this.$fun.getNumberWeeksYear(anioCurrent);
    // console.log("getNumberWeeksYear", this.NumberWeeksYearRange);

    this.NumberWeeksYear = this.$fun.getNumberWeekCurrentYear();
  },
  watch: {
    "filter.TypePrice"() {
      if (this.filter.TypePrice == 1) {
        this.config.headers.splice(7, 1, {
          text: "Categoria",
          value: "CategoryCaliberText",
        });

        const indexToRemove = this.config.headers.findIndex(
          (header) => header.value === "PrdCardCode",
        );
        if (indexToRemove !== -1) {
          this.config.headers.splice(indexToRemove, 1);
        }
      }
      if (this.filter.TypePrice == 2) {
        this.config.headers.splice(7, 1, {
          text: "Certificado",
          value: "TypeCertificationText",
        });

        const indexToRemove = this.config.headers.findIndex(
          (header) => header.value === "PrdCardCode",
        );
        if (indexToRemove !== -1) {
          this.config.headers.splice(indexToRemove, 1);
        }
      }
      if (this.filter.TypePrice == 3) {
        //console.log("Productor", this.filter.TypePrice);
        this.config.headers.splice(7, 1, {
          text: "Productor",
          value: "PrdCardName",
          width: "200",
        });

        // this.config.headers.splice(8, 1, {
        //   text: "Categoria",
        //   value: "CategoryCaliberText",
        // });

        const headerExists = this.config.headers.some(
          (header) => header.value === "PrdCardCode",
        );

        if (!headerExists) {
          this.config.headers.splice(9, 0, {
            text: "Codigo Productor",
            value: "PrdCardCode",
          });
        }
      }
    },
  },
};
</script>
